import { defineActions } from './defineActions'

/**
 * Case correspondence and action required. Action names start with Correspondence. /
 * ActionRequired. The components are shared between modules, so the names carry no module
 * prefix: the module comes from the page's subject.
 */
export const correspondenceActions = defineActions({
  'Correspondence.Create': {
    label: 'Add correspondence',
    area: 'Case correspondence',
    description: 'Save in the correspondence modal (new record).',
  },
  'Correspondence.Update': {
    label: 'Save correspondence',
    area: 'Case correspondence',
    description: 'Save in the correspondence details modal.',
  },
  'Correspondence.SendEmail': {
    label: 'Send correspondence email',
    area: 'Case correspondence',
    description: 'Send Email: saves the correspondence, then sends it.',
  },
  'Correspondence.Delete': {
    label: 'Delete correspondence',
    area: 'Case correspondence',
  },
  'Correspondence.ResendEmail': {
    label: 'Resend correspondence email',
    area: 'Case correspondence',
  },
  'Correspondence.SyncEmailStatus': {
    label: 'Sync correspondence email status',
    area: 'Case correspondence',
  },
  'ActionRequired.Create': {
    label: 'Add action required',
    area: 'Action required',
  },
  'ActionRequired.Update': {
    label: 'Save action required',
    area: 'Action required',
  },
  'ActionRequired.Delete': {
    label: 'Delete action required',
    area: 'Action required',
  },
})
